<script setup lang="ts">
import AppIcon from './AppIcon.vue'
import type { AppIconName } from '@/types/icons'

const props = defineProps<{
  tone: 'success' | 'warning' | 'danger' | 'neutral' | 'info'
  label: string
  icon?: AppIconName
}>()
</script>

<template>
  <span class="status-badge" :class="`status-badge--${props.tone}`">
    <AppIcon v-if="props.icon" :name="props.icon" :size="14" />
    {{ props.label }}
  </span>
</template>
